import { getAttribute } from 'lib/object/objectUtils'

function getFormFieldSchema(
  contentSchema: App.Checkout.TravellerFormSchema,
  fieldId: string,
  formSchema: App.Checkout.FormSchema,
): App.Checkout.FormFieldSchema | undefined {
  const schema = contentSchema.properties?.[fieldId]
  if ('$ref' in schema && schema.$ref) {
    const { $ref, ...overrides } = schema
    return {
      ...getFormFieldSchemaFromRef($ref, formSchema),
      ...overrides,
    }
  }
  return schema
}

function getFormFieldSchemaFromRef(
  /** `schema.$ref` */
  schemaRef: string,
  formSchema: App.Checkout.FormSchema,
): App.Checkout.FormFieldSchema | undefined {
  const parts = schemaRef.split('/')
  const path = parts.slice(1)
  return getAttribute(formSchema, path)
}

export default getFormFieldSchema
